// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"DownloadApp_TheComp____u17"};